import { Icon } from './types';

export const OpenQuote = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    data-testid="open-quote"
    {...svgProps}
  >
    <path
      fill="#C32D3A"
      d="M25.3333 22.6666H21.3333L18.6667 17.3333V9.33331H26.6667V17.3333H22.6667L25.3333 22.6666ZM12 22.6666H8L5.33333 17.3333V9.33331H13.3333V17.3333H9.33333L12 22.6666Z"
      {...pathProps}
    />
  </svg>
);
